import { instanceDcs } from '@/api/http';
import instance from '@/api/request';
import { WECHAT_APPID } from '@/config';
import { IResponseData } from '../../types';
import { IProvinceCityData } from '@/store/modules/register';

// 获取城市列表
export function fetchCityList(params = {}) {
  return instanceDcs.post<
    IResponseData<Record<string, Record<string, string>>>
  >('/', {
    name: 'get.register.city.list',
    data: params,
  });
}

// 获取省市数据
export function fetchProvinceCityData(params = {}) {
  return instanceDcs.post<IResponseData<IProvinceCityData[]>>('/', {
    name: 'city.province',
    data: params,
  });
}

// 获取该城市是否开通
export function fetchOpenJoinOfCity(params: { city_id: string; }) {
  return instanceDcs.post<IResponseData<{ is_open: boolean; }>>('/', {
    name: 'register.city.open',
    data: params,
  });
}

export function getWxConfig(url: string) {
  return instance.get(
    'https://actapi.xiaolachuxing.com/third_app/wechat/xl_subscription_app/jssdk_config',
    {
      params: {
        url: encodeURI(url),
        appid: WECHAT_APPID,
      },
    },
  );
}
